import { Stack, Typography } from '@mui/material';

import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { ChevronLeftIcon } from '@/components/icons/ChevronLeftIcon';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { COLORS } from '@/styles/tokens/colors';

interface AnnotationNavigationProps {
  displayIndex: number;
  totalCount: number;
  onPrevious: () => void;
  onNext: () => void;
  variant?: 'normal' | 'flat-top';
}

export function AnnotationNavigation({
  displayIndex,
  totalCount,
  onPrevious,
  onNext,
  variant = 'normal',
}: AnnotationNavigationProps) {
  const showNavigation = totalCount > 1;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      py={1}
      sx={{
        backgroundColor: COLORS.TEAL[50],
        border: `solid 1px ${COLORS.TEAL[200]}`,
        borderRadius: 1,
        borderTopRightRadius: variant === 'flat-top' ? 0 : undefined,
        borderTopLeftRadius: variant === 'flat-top' ? 0 : undefined,
      }}
    >
      <Typography variant="body-xs" component="div">
        {`Highlighted reference ${displayIndex} of ${totalCount}`}
      </Typography>
      {showNavigation && (
        <Stack direction="row" gap={0.5}>
          <IconButton
            icon={ChevronLeftIcon}
            data-testid="DocumentSearchResults-prev"
            ariaLabel="Previous result"
            size="xs"
            variant="transparent"
            onClick={onPrevious}
          />
          <IconButton
            icon={ChevronRightIcon}
            data-testid="DocumentSearchResults-next"
            ariaLabel="Next result"
            size="xs"
            variant="transparent"
            onClick={onNext}
          />
        </Stack>
      )}
    </Stack>
  );
}
